import React, { useContext } from 'react'
import { InputNumber, Button, Popconfirm, message } from 'antd'
import MonthlyPerfDataContext from './MonthlyPerfDataContext'
import { saveMonthlyPerfData } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
// import { Filler } from 'core/screen-util'
import { showErrorMessage } from './MonthlyPerfData'
export const updateAuxilData = _ => _

// export const updateAuxilData2 = data => {
//   let roTotalAux = data.roTotalAux
//   const grossMwh = data.grossMwh
//   let netMwh = data.netMwh
//   const onlineAux = data.onlineAux
//   const offlineAux = data.offlineAux
//   if (
//     onlineAux &&
//     (onlineAux + '').trim().length > 0 &&
//     offlineAux &&
//     (offlineAux + '').trim().length > 0
//   ) {
//     roTotalAux = parseFloat(onlineAux) + parseFloat(offlineAux)
//     if (grossMwh && (grossMwh + '').trim().length > 0)
//       netMwh = grossMwh - roTotalAux + ''
//   } else {
//     roTotalAux = ''
//     netMwh = ''
//   }

//   return { ...data, roTotalAux, netMwh }
// }

const DataPanel = props => {
  const {
    unitname,
    date,
    apiTargetInfo,
    saveData,
    retrieveDataAfterSave,
    hasWritePermission,
  } = props
  const { setError } = useContext(ErrorContext)
  const {
    currentData = {},
    setCurrentData,
    nonEditDataMap,
    setDataError,
  } = useContext(MonthlyPerfDataContext)

  const { setSpinning } = useContext(SpinContext)

  const onChange = name => value => {
    let nuclear = (currentData[unitname] || {}).nuclear || '0'
    if (name === 'mwd' && value && value > 0 && (nuclear + '').length > 0)
      nuclear = parseFloat(value) * 81.912

    const data = {
      ...currentData[unitname],
      [name]: value,
      nuclear,
    }

    const updateData = updateAuxilData(data)

    setCurrentData({
      ...currentData,
      [unitname]: updateData,
    })
  }

  // const onPressEnter = data => e =>
  //   setCurrentData({ ...data, [e.target.name]: e.target.value })

  const getTypeData = type =>
    type === 'nonEditDetails' ? nonEditDataMap[unitname] : currentData[unitname]

  const deleteData = _ => {
    setSpinning(true)
    saveMonthlyPerfData(apiTargetInfo)(
      { ...currentData[unitname], action: 'D' },
      date
    ).fork(setError, errorDdata => {
      setSpinning(false)
      setDataError(errorDdata)
      if (errorDdata.length === 0) {
        message.success('Data deleted for ' + unitname)
        retrieveDataAfterSave()
      }
    })
  }

  const getNumberField = ({
    text,
    key,
    precision = 2,
    disabled = false,
    type,
    max,
    min = 0,
  }) => {
    return (
      <React.Fragment>
        <div
          style={{
            display: 'grid',
            alignContent: 'center',
            justifyContent: 'end',
          }}
        >
          {text}
        </div>
        <InputNumber
          style={{ width: '90%' }}
          min={min}
          precision={precision}
          key={key}
          name={key}
          value={getTypeData(type) ? getTypeData(type)[key] : ''}
          onChange={onChange(key, type)}
          disabled={disabled || !hasWritePermission}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          max={max}
        />
      </React.Fragment>
    )
  }

  const enableSave = _ => {
    let roTtotl = (getTypeData('detailData') || {}).convenSteam || 0
    roTtotl = parseFloat(roTtotl)
    const online = (getTypeData('detailData') || {}).onlineAux || 0
    const offline = (getTypeData('detailData') || {}).offlineAux || 0
    const newTotal = parseFloat(online) + parseFloat(offline) || 0

    if (roTtotl !== newTotal) {
      // message.error('parseFloat(online) + parseFloat(offline)', 20)
      showErrorMessage({ unitname })
    } else saveData()
  }

  return (
    <div>
      {/* <div
        style={{
          display: 'grid',
          gridGap: '10px',
          gridTemplateColumns: '600px 150px 150px 150px',
          //          maxWidth: '200px',
        }}
      >
        
        <div />
        <Button onClick={saveData} type="primary" icon="edit">
          Save {unitname}
        </Button>
        <Popconfirm
          title={
            'Are you sure you want to delete ' +
            date.format('MMM') +
            ' ' +
            date.format('YYYY') +
            ' data for ' +
            unitname +
            ' ' +
            ' ?'
          }
          onConfirm={deleteData}
        >
          <Button type="danger" icon="delete">
            Delete {unitname}
          </Button>
        </Popconfirm>
      </div> */}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '650px 300px 1fr',
          gridGap: '10px',
          // justifyItems: 'center',
          marginTop: '10px',
          maxWidth: '1000px',
        }}
      >
        <fieldset style={{ border: '1px gray solid', width: '100%' }}>
          <legend style={{ margin: '0px', width: '10px' }}>Generation</legend>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '170px 130px  170px 130px',
              gridGap: '10px',
            }}
          >
            {/* {getNumberField({
              text: 'Period Hours',
              key: 'roPeriodHrs',
              precision: 0,
              disabled: true,
              type: 'nonEditDetails',
            })} */}
            {getNumberField({
              text: 'Period Hours',
              key: 'periodHrs',
              precision: 0,
              disabled: true,
              type: 'detailData',
            })}
            {getNumberField({
              text: 'Critical Hours',
              key: 'criticalHrs',
              precision: 2,
              disabled: false,
            })}

            {/* <div style={{ gridColumn: 'span 2' }} /> */}
            {/* {getNumberField({
              text: 'Gross Electrical MWH',
              key: 'roGrossMwh',
              precision: 0,
              disabled: true,
              type: 'nonEditDetails',
            })} */}
            {/* {getNumberField({
              text: 'Generator Hours',
              key: 'roGenHrs',
              precision: 2,
              disabled: true,
              type: 'nonEditDetails',
            })} */}
            {getNumberField({
              text: 'Generator Hours',
              key: 'genHrs',
              precision: 2,
              disabled: true,
              type: 'detailData',
            })}
            <div style={{ gridColumn: 'span 2' }} />
            {getNumberField({
              text: 'Gross Electrical MWH',
              key: 'grossMwh',
              precision: 0,
              disabled: true,
              type: 'detailData',
            })}
            {getNumberField({
              text: 'Online Auxiliaries',
              key: 'onlineAux',
              precision: 2,
              disabled: false,
              type: 'detailData',
            })}
            {/* {getNumberField({
              text: 'Total Auxiliaries',
              key: 'roTotalAux',
              precision: 2,
              disabled: true,
              type: 'nonEditDetails',
            })} */}
            {getNumberField({
              text: 'Total Auxiliaries',
              key: 'convenSteam',
              precision: 2,
              disabled: true,
              type: 'detailData',
            })}

            {getNumberField({
              text: 'Offline Auxiliaries',
              key: 'offlineAux',
              precision: 2,
              disabled: false,
              type: 'detailData',
            })}
            {/* {getNumberField({
              text: 'Total Auxiliaries',
              key: 'roTotalAux',
              precision: 2,
              disabled: true,
              type: 'nonEditDetails',
            })} */}

            {/* {getNumberField({
              text: 'Net Electrical MWH',
              key: 'roNetMwh',
              precision: 2,
              disabled: true,
              type: 'nonEditDetails',
              min: -100000,
            })} */}

            {getNumberField({
              text: 'Net Electrical MWH',
              key: 'netMwh',
              precision: 2,
              disabled: true,
              type: 'detailData',
              min: -100000,
            })}

            {/* {getNumberField({
              text: 'Net Electrical MWH',
              key: 'netMwh',
              precision: 2,
              disabled: true,
              type: 'detailData',
              min: -10000000,
            })} */}
            <div style={{ gridColumn: 'span 2' }} />
            {getNumberField({
              text: 'Electrical Boiler KWH',
              key: 'boilerKwh',
              precision: 2,
              disabled: true,
              type: 'detailData',
            })}
          </div>
        </fieldset>

        <fieldset style={{ border: '1px gray solid', width: '100%' }}>
          <legend style={{ margin: '0px', width: '10px' }}>Starts</legend>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '140px 130px',
              gridGap: '10px',
            }}
          >
            {getNumberField({
              text: 'Generator Attempted',
              key: 'genAttempted',
              precision: 0,
              disabled: true,
              type: 'detailData',
            })}

            {/* {getNumberField({
              text: 'Generator Attempted',
              key: 'roGenAttempted',
              precision: 0,
              disabled: true,
              type: 'nonEditDetails',
            })} */}
            {/* {getNumberField({
              text: 'Actual',
              key: 'roActual',
              precision: 0,
              disabled: true,
              type: 'nonEditDetails',
            })} */}

            {getNumberField({
              text: 'Actual',
              key: 'actual',
              precision: 0,
              disabled: true,
              type: 'detailData',
            })}

            {getNumberField({
              text: 'Reactor',
              key: 'reactor',
              precision: 0,
              disabled: false,
              type: 'detailData',
            })}
            <div style={{ gridColumnEnd: 'span 2' }} />
            <div style={{ gridColumnEnd: 'span 2' }} />
            {getNumberField({
              text: 'MWD',
              key: 'mwd',
              precision: 3,
              disabled: false,
              type: 'detailData',
            })}
          </div>
        </fieldset>

        <fieldset style={{ border: '1px gray solid', width: 'fit-content' }}>
          <legend style={{ margin: '0px', width: '10px' }}>Ratings</legend>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '50px 130px',
              gridGap: '10px',
            }}
          >
            {getNumberField({
              text: 'MNDC',
              key: 'mndc',
              precision: 1,
              type: 'detailData',
            })}

            {getNumberField({
              text: 'MGDC',
              key: 'mgdc',
              precision: 1,
              type: 'detailData',
            })}

            {getNumberField({
              text: 'DER',
              key: 'der',
              precision: 1,
              type: 'detailData',
            })}

            {getNumberField({
              text: 'REG',
              key: 'reg',
              precision: 1,
              type: 'detailData',
            })}
            {getNumberField({
              text: 'GMC',
              key: 'gmc',
              precision: 1,
              type: 'detailData',
            })}
            {getNumberField({
              text: 'GDC',
              key: 'gdc',
              precision: 1,
              type: 'detailData',
            })}
          </div>
        </fieldset>
        <fieldset style={{ border: '1px gray solid', width: '100%' }}>
          <legend style={{ margin: '0px', width: '200px' }}>
            Fuel Consumption
          </legend>
          <div
            style={{
              display: 'grid',
              // gridTemplateColumns: '100px 100px',
              gridGap: '10px',
              gridTemplateColumns: '170px 130px  120px 130px',
            }}
          >
            {getNumberField({
              text: 'Nuclear',
              key: 'nuclear',
              precision: 2,
              disabled: true,
              type: 'detailData',
            })}
            {getNumberField({
              text: 'Diesel',
              key: 'diesel',
              precision: 0,
              disabled: false,
              type: 'detailData',
            })}
            {/* {getNumberField({
              text: 'Heat Content',
              key: 'heatContent',
              precision: 0,
              disabled: false,
              type: 'detailData',
            })}
            {getNumberField({
              text: '% Sulfer (0-100)',
              key: 'sulfurPercent',
              precision: 2,
              disabled: false,
              type: 'sulfurPercent',
              max: 100,
            })} */}
          </div>
        </fieldset>
        {hasWritePermission && (
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Button
              onClick={enableSave}
              // onClick={saveData}
              type="primary"
              icon="edit"
              disabled={!hasWritePermission}
            >
              Save {unitname}
            </Button>
          </div>
        )}
        {hasWritePermission && (
          <div style={{ display: 'grid', alignContent: 'center' }}>
            <Popconfirm
              title={
                'Are you sure you want to delete ' +
                date.format('MMM') +
                ' ' +
                date.format('YYYY') +
                ' data for ' +
                unitname +
                ' ' +
                ' ?'
              }
              onConfirm={deleteData}
            >
              <Button
                type="danger"
                icon="delete"
                disabled={!hasWritePermission}
              >
                Delete {unitname}
              </Button>
            </Popconfirm>
          </div>
        )}
        <div />
      </div>
    </div>
  )
}

export default DataPanel
